export const calculateRatio = (width?: number, height?: number): string => {
	if (!width || !height) return '';

	for (let index = height; index > 1; index--) {
		if (width % index == 0 && height % index == 0) {
			width = width / index;
			height = height / index;
		}
	}

	return `${width} / ${height}`;
};
